import React from 'react';
import { DescriptionContainer, Image } from '../../styled';
import { blueDefault } from '../../../../Assets/colorPallet/colorPallet';
import { Text } from '../../../../Assets/Structure/Structure';
import img1 from './images/img-1.png';

export default class CheckHowWellSpecificLocation extends React.Component{

    render(){
        return(
            <DescriptionContainer>
                <Text mt="0">
                   On the upper left side click on <strong style={{ color: blueDefault }}>Location Analytics</strong>.
                   Here you can see how each specific store is rated in general, per platform and the related reviews.
                </Text>
                <Image fluid src={img1} />
            </DescriptionContainer>
        )
    }
}